var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="survey-item__title">\n  '+
((__t=( title ))==null?'':_.escape(__t))+
'\n</div>\n<div class="survey-item__scale-options">\n  ';
 for (var i = 1; i <= 10; i++) { 
__p+='\n  <div class="js-scale-option survey-item__scale-option" data-optionIndex="'+
((__t=( i ))==null?'':_.escape(__t))+
'">\n    <span>'+
((__t=( i ))==null?'':_.escape(__t))+
'</span>\n  </div>\n  ';
 } 
__p+='\n</div>\n\n';
}
return __p;
};
